import React from "react";

export default function FourSizesIcon(props: any) {
  return (
    <svg
      {...props}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#000" x="4" y="4" width="34" height="34" rx="3" />
        <path
          d="M21.212 27.238c2.585 0 4.42-1.36 4.42-3.655 0-2.516-2.023-3.145-3.825-3.689-1.852-.561-2.141-.935-2.141-1.479 0-.476.424-.901 1.274-.901 1.088 0 1.65.527 2.058 1.377l2.294-1.343c-.867-1.751-2.397-2.686-4.352-2.686-2.056 0-3.995 1.326-3.995 3.621 0 2.278 1.735 3.128 3.503 3.621 1.785.493 2.465.782 2.465 1.513 0 .459-.323.969-1.616.969-1.343 0-2.073-.663-2.498-1.649l-2.346 1.36c.663 1.751 2.26 2.941 4.76 2.941z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <rect fill="#000" x="4" y="42" width="34" height="34" rx="3" />
        <path
          d="M20.66 62.382V53.1h-2.72V65h6.97v-2.618z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <rect fill="#000" x="42" y="4" width="34" height="34" rx="3" />
        <path
          d="M64.95 15.1h-2.72L59 20.387 55.77 15.1h-2.72V27h2.72v-6.919l3.077 5.049h.306l3.077-5.049V27h2.72z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <rect fill="#000" x="42" y="42" width="34" height="34" rx="3" />
        <g fill="#FFF" fillRule="nonzero">
          <path d="m60.02 65-3.553-6.103L59.85 53.1h-3.094l-1.836 3.145-1.836-3.145H49.99l3.383 5.797L49.82 65h3.094l2.006-3.434L56.926 65zM64.93 62.382V53.1h-2.72V65h6.97v-2.618z" />
        </g>
      </g>
    </svg>
  );
}
